// extracted by mini-css-extract-plugin
export default {"arrow":"TradeRowLabel_arrow__NWN79","sellTitle":"TradeRowLabel_sellTitle__ulzew"};